export default "__VITE_ASSET__g0ruy8L5__"